import APIClient from './index';
import _ from 'lodash';

export const searchUrlSiteRules = params => {
  return new Promise((resolve, reject) => {
    APIClient.get(`/UrlSiteRules?${new URLSearchParams(params).toString()}`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const updateUrlSiteRule = (ruleId, payload) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`/UrlSiteRules/${ruleId}`, payload)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const createUrlSiteRule = payload => {
  return new Promise((resolve, reject) => {
    APIClient.post(`/UrlSiteRules`, payload)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const testUrlSiteRule = payload => {
  return new Promise((resolve, reject) => {
    APIClient.post(`/UrlSiteRules/test_rule`, payload)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};
